import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateField } from "@mui/x-date-pickers/DateField";
import "./dateFields.scss";

function DateFields(props) {
  return (
    <>
      {props.retirementDate ? (
        <div className="date-field">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateField"]}>
              <DateField
                clearable="true"
                spellCheck="false"
                InputLabelProps={{ shrink: true }}
                label={props.label}
                onChange={props.onChange}
                disabled={props.disabled}
                onKeyDown={props.onKeyDown}
                value={props.value}
                minDate={props.minDate}
                maxDate={props.maxDate}
                format="DD  /  MM  /  YYYY"
                slotProps={{
                  textField: { variant: "filled" },
                }}
                InputProps={{
                  disableUnderline: true,
                }}
                error={props.error}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>
      ) : props.plainDateField ? (
        <div className="simple-date-field">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateField"]}>
              <DateField
                clearable="true"
                spellCheck="false"
                InputLabelProps={{ shrink: true }}
                onChange={props.onChange}
                disabled={false}
                onKeyDown={props.onKeyDown}
                value={props.value}
                format="DD/MM/YYYY"
                InputProps={{
                  disableUnderline: true,
                }}
                error={props.error}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>
      ) : (
        <div className="date-field">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateField"]}>
              <DateField
                clearable="true"
                spellCheck="false"
                InputLabelProps={{ shrink: true }}
                label={props.label}
                onChange={props.onChange}
                disabled={props.disabled}
                onKeyDown={props.onKeyDown}
                value={props.value}
                format="DD  /  MM  /  YYYY"
                slotProps={{
                  textField: { variant: "filled" },
                }}
                InputProps={{
                  disableUnderline: true,
                }}
                error={props.error}
                sx={{
                  "& .MuiInputAdornment-root": {
                    "@media (max-width: 768px)": {
                      position: "relative",
                      top: "18px",
                    },
                  },
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>
      )}
    </>
  );
}

export default DateFields;
